<template>
    <b-row>
        <h2 class="pl-1">Транзакции</h2>

        <!--  BEFORE TABLE  -->
        <div class="d-flex justify-content-between col-12">
            <b-col md="4" class="my-1 px-0">
                <b-form-group class="mb-0">
                    <b-input-group size="md">
                        <b-form-input id="filterInput" v-model="filter" type="search" placeholder="Искать" />
                        <b-input-group-append>
                            <b-button :disabled="!filter" @click="filter = ''">
                                Очистить
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </div>

        <!--  TABLE  -->
        <b-col cols="12">
            <b-table striped hover responsive sort-icon-left :busy="isBusy" :items="items" :fields="fields"
                @sort-changed="handleSortChange">
                <template #table-busy>
                    <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong class="ml-1">Идет загрузка ...</strong>
                    </div>
                </template>

                <template #cell(actions)="data">
                    <div class="d-flex float-right">

                        <!--  DEACTIVATE  -->
                        <div class="ml-1" v-if="isPending(data.item)">
                            <!--  approve modal  -->
                            <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" v-b-modal="`modal-${data.item.id}-accept`"
                                variant="outline-success" class="delete__btn mr-1">
                                <feather-icon icon="CheckIcon" size="18" />
                            </b-button>
                            <b-modal :id="`modal-${data.item.id}-accept`" body-class="deactivate-btn_modal"
                                title="Вывести кэшбек" hide-header-close centered>
                                Вы хотите разрешить вывод кешбека?

                                <template #modal-footer>
                                    <b-button variant="danger btn-sm" @click="
                                        $bvModal.hide(
                                            `modal-${data.item.id}-accept`
                                        )
                                        ">
                                        Отменить
                                    </b-button>

                                    <b-button variant="success btn-sm" @click="
                                        processCashback(
                                            data.item.id,
                                            'confirm')
                                        ">
                                        Да
                                    </b-button>
                                </template>
                            </b-modal>
                            <!--  cancel modal  -->
                            <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" v-b-modal="`modal-${data.item.id}`"
                                variant="outline-danger" class="delete__btn">
                                <feather-icon icon="XIcon" size="18" />
                            </b-button>
                            <b-modal :id="`modal-${data.item.id}`" body-class="deactivate-btn_modal"
                                title="Вывести кэшбек" hide-header-close centered>
                                Вы хотите отказать в выводе кешбека?

                                <template #modal-footer>
                                    <b-button variant="danger btn-sm" @click="
                                        $bvModal.hide(
                                            `modal-${data.item.id}`
                                        )
                                        ">
                                        Нет, отменить
                                    </b-button>

                                    <b-button variant="success btn-sm" @click="
                                        processCashback(
                                            data.item.id,
                                            'cancel'
                                        )
                                        ">
                                        Да, отказать
                                    </b-button>
                                </template>
                            </b-modal>

                        </div>
                    </div>
                </template>

                <template #cell(created_at)="data">
                    <span>{{
                        new Date(data.item.created_at).toLocaleDateString("ru")
                    }}</span>
                </template>

                <template #cell(card)="data">
                    <div v-if="data.item.card">
                        <div>{{ data.item.card.pan }}</div>
                        <small class="text-muted d-block">
                            Владелец: {{ data.item.card.name }}
                        </small>
                        <small v-if="data.item.user" class="text-muted d-block">
                            Телефон: {{ data.item.user.phone }}
                        </small>
                        <small class="text-muted d-block">
                            {{ data.item.card.bank_name }}
                            <template v-if="data.item.card.processing_type">
                                / {{ data.item.card.processing_type }}
                            </template>
                        </small>
                    </div>
                    <span v-else>-</span>
                </template>
            </b-table>
        </b-col>

        <!--  PAGINATION  -->
        <b-col cols="12" class="mb-3 d-flex justify-content-between align-items-center">
            <b-form-select class="float-right col-1" v-model="pagination.perPage" placeholder="Выберите"
                :options="pagination.perPageOptions">
            </b-form-select>
            <b-pagination v-model="pagination.page" :total-rows="pagination.total" :per-page="pagination.perPage"
                align="center" size="sm" class="my-0" />
        </b-col>
    </b-row>
</template>

<script>
import {
    BTable,
    BRow,
    BCol,
    BFormGroup,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BSpinner,
    BFormSelect,
} from "bootstrap-vue";
import Cashback from "@/services/cashback";
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
    paginationData,
    paginationWatchers,
    paginationHelperMethods,
} from "@/util/pagination-helper";
import permissionComputeds from "@/util/permissionComputeds";
const cApi = new Cashback();

/**
 * @typedef {Object} CashbackCard
 * @property {number} id
 * @property {string} name
 * @property {string} pan
 * @property {string} expiry
 * @property {string} phone
 * @property {boolean} sms
 * @property {string} bank_name
 * @property {string} bank_mfo
 * @property {string} processing_type
 */

/**
 * @typedef {Object} CashbackUser
 * @property {number} id
 * @property {string} first_name
 * @property {string} last_name
 * @property {string} phone
 * @property {number} balance
 */

/**
 * @typedef {Object} CashbackItem
 * @property {number} id
 * @property {string} card_id
 * @property {CashbackCard} card
 * @property {string} ext_id
 * @property {number} amount
 * @property {string} status
 * @property {?number} asl_transaction_id
 * @property {?string} asl_status
 * @property {string} created_at
 * @property {CashbackUser} user
 */

/**
 * @typedef {Object} CashbackResponse
 * @property {CashbackItem[]} items
 * @property {{ page: number, perPage: number, total: number, lastPage: number }} pagination
 * @property {CashbackItem[]=} data
 * @property {number=} total
 */

export default {
    name: "AppDealers",
    components: {
        BTable,
        BRow,
        BCol,
        BFormGroup,
        BPagination,
        BInputGroup,
        BFormInput,
        BInputGroupAppend,
        BButton,
        BSpinner,
        BFormSelect,
        ToastificationContent,
    },
    directives: {
        Ripple,
    },
    data() {
        return {
            apiEntry: "dealers",
            name: null,
            isBusy: false,
            filter: null,
            fields: [
                {
                    key: "id",
                    label: "ID",
                },
                {
                    key: "card_id",
                    label: "Card ID",
                },
                {
                    key: "card",
                    label: "Карта",
                },
                {
                    key: "user",
                    label: "Владелец",
                    formatter: v => v ? `${v.first_name} ${v.last_name}` : ''
                },
                {
                    key: "amount",
                    label: "Сумма",
                },

                {
                    key: 'user.balance',
                    label: 'Баланс'
                },
                {
                    key: 'created_at',
                    label: 'Дата',
                    formatter: v => new Date(v)
                },
                {
                    key: 'actions'
                }
            ],
            items: [],
            pagination: paginationData(),
        };
    },
    watch: paginationWatchers("getData"),

    async mounted() {
        this.setParams();
        await this.getData();
        // if (this.isDeleteAvailable || this.isUpdateAvailable)
        //     this.fields.push({
        //         key: "crud_row",
        //         label: " ",
        //     });
    },

    computed: {
        ...permissionComputeds("dealer"),

        showPagination() {
            return (
                this.pagination.total > this.pagination.perPage && !this.isBusy
            );
        },
    },

    methods: {

        ...paginationHelperMethods("", {}),
        showToast(variant, text, icon) {
            this.$toast({
                component: ToastificationContent,
                props: {
                    title: text,
                    icon: icon,
                    variant,
                },
            });
        },

        async getData() {
            this.isBusy = true;
            await cApi
                .fetchAll(this.getParams())
                .then((res) => {
                    /** @type {CashbackResponse} */
                    const response = res.data;
                    const pagination = response.pagination || {};

                    this.items = response.items || response.data || [];
                    this.pagination.total = pagination.total || response.total || 0;
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },

        isPending(item) {
            return item.status === "pending" || item.status === "new";
        },

        processCashback(id, resolution) {
            cApi[resolution](id)
                .then(() => {
                    this.getData();
                    if (resolution === 'confirm') {
                        this.showToast(
                            "success",
                            "Кэшбек разрешен к выводу!",
                            "CheckIcon"
                        );
                    } else {
                        this.showToast(
                            "success",
                            "Вывод кешбека отменен!",
                            "CheckIcon"
                        );
                    }
                })
                .catch((error) => {
                    console.error(error);
                    this.showToast("danger", "Что-то пошло не так!", "XIcon");
                });
        },
    },
};
</script>

<style lang="scss" scoped>
[dir] .dropdown-item {
    padding: 0;
}

//::v-deep .table thead th[aria-colindex="1"] {
//  width: 70px;
//}

.validation__red {
    color: red;
    font-size: 12px;
    display: block;
    margin-bottom: 1rem;
}

.form-group {
    margin-bottom: 6px;
}
</style>
